import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const adminOrderController = {
  getOrders: ({
    jwt,
    Authorization,
    fromDate,
    page = 0,
    search,
    size = 20,
    status,
    toDate,
  } = {}) => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("size", size);
    if (fromDate) params.append("fromDate", fromDate);
    if (search) params.append("search", search);
    if (status) params.append("status", status);
    if (toDate) params.append("toDate", toDate);

    return Utils.controller(
      "api/admin/orders/v1",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default adminOrderController;
